const _ = require('lodash')
let config = undefined
let prod = require('./settings.prod')
let dev = require('./settings.dev')
let stage = require('./settings.stage')
// load config based on environment
if (process.env.NODE_ENV === 'development') {
  // load development
  config = _.assignIn({}, prod, dev)
} else if (process.env.VUE_APP_API_ENV === 'stage') {
  config = _.assignIn({}, prod, stage)
} else {
  config = _.assignIn({}, prod)
}

module.exports = config